import { render } from "./Settings.vue?vue&type=template&id=36db0e64&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=36db0e64&scoped=true&lang=css"
import "./Settings.vue?vue&type=style&index=1&id=36db0e64&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36db0e64"]])

export default __exports__